<template>
  <Component
    :is="c_tag"
    class="link"
    :class="[
      `link-${color}`,
      {
        'active': active,
        'bold': bold,
        'size-small': size === 'small',
        'size-big': size === 'big',
      },
    ]"
    v-bind="c_link"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <slot>{{ text }}</slot>
  </Component>
</template>
<script>
import { isObject, isString } from '~/util/validators/baseComponentsValidators'

const COLORS = {
  GRAY: 'gray',
  GREEN: 'green',
}
export const colorValidator = (value) => Object.values(COLORS).includes(value)

export default {
  name: 'UiLink',
  props: {
    disabled: { type: Boolean },
    active: { type: Boolean },
    loading: { type: Boolean },
    text: { type: [String, Number] },
    to: { type: [String, Object] },
    href: { type: String },
    size: { type: String, default: 'medium' },
    bold: { type: Boolean, default: false },
    modalTo: { type: [String, Object] },
    tag: { type: String },
    color: { type: String, validator: colorValidator },
  },
  computed: {
    c_link() {
      const link = {}
      if (this.to) {
        link.to = this.c_to
      }
      if (this.href) {
        link.href = this.href
      }
      if (this.modalTo) {
        link.to = this.modalTo
      }
      return link
    },
    c_tag() {
      return this.tag || (this.c_to ? 'NuxtLink' : this.href ? 'a' : this.modalTo ? 'ModalLink' : 'button')
    },
    c_to() {
      if (this.to) return this.to
      if (isString(this.rawTo)) return this.localePath(this.rawTo)
      else if (isObject(this.rawTo) && this.rawTo.path) return { ...this.rawTo, path: this.localePath(this.rawTo.path) }
      return undefined
    },
  },
}
</script>

<style src="./style.scss" lang="scss" />
